import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=69beae78"
import script from "./LogoutButton.vue?vue&type=script&lang=ts"
export * from "./LogoutButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69beae78')) {
      api.createRecord('69beae78', component.options)
    } else {
      api.reload('69beae78', component.options)
    }
    module.hot.accept("./LogoutButton.vue?vue&type=template&id=69beae78", function () {
      api.rerender('69beae78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/generic/LogoutButton.vue"
export default component.exports